import Phaser from 'phaser';
import { haptic, type HapticKind } from './haptic';

// Централизованная подписка на fx:*-эмиты сцены + доменные события (player:died,
// boss:*). ОДНО место, где семантика "что произошло" переводится в haptic-вызов.
// Место вызова: GameScene.create() → bindHaptics(this).
//
// SHUTDOWN cleanup: без него рестарт сцены (returnToMap/gameOver → scene.start
// → снова GameScene.create) плодит слушателей — каждый эмит начнёт лететь в
// 2/3/4 обработчика.
//
// Аналитика позже переиспользует эти же fx:*-эмиты — поэтому эмитим осмысленно
// в GameScene (payload где уместно, напр. weapon id), не вызываем haptic()
// напрямую из мест события.

// Явная таблица «эмит → семантический kind». Не сокращаем через простое
// строковое преобразование, чтобы легко читать что на что маппится.
const BINDINGS: ReadonlyArray<readonly [string, HapticKind]> = [
  ['fx:hit', 'hit'],
  ['fx:headshot', 'headshot'],
  ['fx:kill', 'kill'],
  ['fx:breach', 'breach'],
  ['fx:player-hurt', 'player_hurt'],
  ['fx:game-over', 'game_over'],
  ['fx:final-victory', 'final_victory'],
  ['fx:weapon-purchased', 'weapon_purchased'],
  ['fx:wave-start', 'wave_start'],
  ['fx:wave-end', 'wave_end'],
  ['fx:defense-warning', 'defense_warning'],
  // Доменные события — уже эмитятся в Player/ChargingBossBehavior/GameScene.
  ['player:died', 'player_died'],
  ['boss:defeated', 'boss_defeated'],
  ['boss:wall-impact', 'boss_wall_impact'],
  ['boss:phase-change', 'boss_phase_change'],
];

export function bindHaptics(scene: Phaser.Scene): void {
  // Одинаковая сигнатура обработчика для всех — payload игнорим (только для
  // тактилки; аналитика прочтёт payload из своих подписок).
  const handlers: Array<[string, () => void]> = BINDINGS.map(([event, kind]) => {
    const fn = (): void => haptic(kind);
    scene.events.on(event, fn);
    return [event, fn];
  });

  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    for (const [event, fn] of handlers) {
      scene.events.off(event, fn);
    }
  });
}
